<template>
  <div>
    <CCardHeader class="p-1">
      <CRow>
        <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">

          <strong >{{ $t('TempReturnProductsList') }}</strong>

        </CCol>
        <CCol col="4" style="text-align: end">


<!--          <CButton @click="confirm_dialog()" type="submit" size="sm" color="secondary">-->
<!--            {{ $t('addRetDoc') }}-->
<!--          </CButton>-->
        </CCol>
      </CRow>
    </CCardHeader>
    <CRow>
      <CCol col="4">
        <CSelect
            :label="$t('documentType')"
            :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"

            :value.sync="selected_type"
            :options="type_items"
        />
      </CCol>
      <CCol col="3">
        <date-picker

                :label="$t('components.startDate')"
                v-model="start_date"></date-picker>
      </CCol>
      <CCol col="3">
        <date-picker
                :label="$t('components.endDate')"
                v-model="end_date"></date-picker>

      </CCol>


    </CRow>


    <CDataTableFixed
            v-if="selected_type==4"
            :items="items_sell_filtered"
            :fields="sell_fields"
            column-filter
            @row-clicked="table_row_clicked"
            height="400px"

            :items-per-page="20"
            hover
            sorter
            border
            striped
            :sorter-value="{column:'recId',asc:false}"
            pagination
    >
      <template #row="{item,index}">

        <td>
          <p style="text-align: center">{{ index + 1 }}</p>

        </td>

      </template>
      <template #docDate="{item}">

        <td>
          <p class="text-center">{{ get_date(item.docDate) }}</p>

        </td>

      </template>


      <template #baseMasterCode="{item}">
        <td>
          <p class="text-center">{{ item.baseMasterCode }}</p>
        </td>
      </template>
      <template #partyCode="{item}">
        <td>
          <p class="text-center">{{ item.partyCode }}</p>
        </td>
      </template>
      <template #masterCode="{item}">
        <td>
          <p class="text-center">{{ item.masterCode }}</p>

        </td>

      </template>
      <template #price="{item}">

        <td>
          <p class="text-right" v-if="item.totalPrice!=null">{{ get_currency(Math.abs(item.totalPrice.replace(/,/g, ""))) }}</p>

        </td>


      </template>
      <template #customer="{item}">

        <td>
          <p >{{ item.partyName }}</p>

        </td>

      </template>
      <template #toziKonande="{item}">

        <td>
          <p v-if="item.toziKonande!=null" >{{ item.toziKonande }}</p>

        </td>

      </template>
      <template #user="{item}">

        <td>
          <p >{{ item.createdBy }}</p>

        </td>

      </template>


      <template #operation="{item}">
        <td>

          <CButton v-if="item.statusId ==0"

                   size="sm"
                   :title="$t('buttons.finalize')"
                   @click="delete_item_dialog(item)"
          >
            <CIcon name="cil-trash" class="text-danger"/>
          </CButton>


        </td>
      </template>

      <template #select="{item}">
        <td>

          <CCol v-if="item.isReorder !=3 ">

            <input type="checkbox" ref="permissions[]" v-model="id_checkbox_items"
                   :value="item.recId"/>

          </CCol>

        </td>
      </template>
      <template #caption>
        <tr class="total-table">
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>

            {{ get_currency(Math.abs(calculate_items(items_sell_filtered,'totalPrice'))) }}
          </td>
        </tr>
      </template>

    </CDataTableFixed>
    <CDataTable
            v-if="selected_type==2"
            :items="items_buy_filtered"
            :fields="buy_fields"
            column-filter
            @row-clicked="table_row_clicked"

            :items-per-page="20"
            hover
            sorter
            border
            striped
            :sorter-value="{column:'recId',asc:false}"
            pagination
    >
      <template #row="{item,index}">

        <td>
          <p style="text-align: center" >{{ index + 1 }}</p>

        </td>

      </template>
      <template #docDate="{item}">

        <td>
          <p  style="text-align: center">{{ get_date(item.docDate) }}</p>

        </td>

      </template>

      <template #warehouse="{item}">
        <td>
          <p >{{ item.placeName }}</p>

        </td>

      </template>
      <template #price="{item}">

        <td>
          <p style="float: right" v-if="item.totalPrice!=null">{{ get_currency(Math.abs(item.totalPrice)) }}</p>

        </td>


      </template>
      <template #customer="{item}">

        <td>
          <p >{{ item.partyName }}</p>

        </td>

      </template>
      <template #toziKonande="{item}">

        <td>
          <p v-if="item.toziKonande!=null" >{{ item.toziKonande }}</p>

        </td>

      </template>
      <template #user="{item}">

        <td>
          <p >{{ item.createdBy }}</p>

        </td>

      </template>
      <template #baseMasterCode="{item}">
        <td>
          <p class="text-center">{{ item.baseMasterCode }}</p>
        </td>
      </template>
      <template #partyCode="{item}">
        <td>
          <p class="text-center">{{ item.partyCode }}</p>
        </td>
      </template>
      <template #masterCode="{item}">
        <td>
          <p class="text-center">{{ item.masterCode }}</p>
        </td>
      </template>

      <template #operation="{item}">
        <td >
          <CButton v-if="item.statusId ==0"

                   size="sm"
                   :title="$t('buttons.delete')"
                   @click="delete_item_dialog(item)"
          >
            <CIcon name="cil-trash" class="text-danger" />
          </CButton>
        </td>
      </template>

      <template #select="{item}">
        <td >

          <CCol v-if="item.statusId !=0 && item.toziKonande==null">

            <input type="checkbox" ref="permissions[]" v-model="id_checkbox_items"
                   :value="item.recId"/>

          </CCol>

        </td>
      </template>
      <template #caption>
        <tr class="total-table">
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>

            {{ get_currency(Math.abs(calculate_items(items_buy_filtered,'totalPrice'))) }}
          </td>
        </tr>
      </template>

    </CDataTable>
    <CDataTable
            v-if="selected_type==11"
            :items="items_buy_filtered_no_ref"
            :fields="buy_fields"
            column-filter
            @row-clicked="table_row_clicked"

            :items-per-page="20"
            hover
            sorter
            border
            striped
            :sorter-value="{column:'recId',asc:false}"
            pagination
    >
      <template #row="{item,index}">

        <td>
          <p style="text-align: center" >{{ index + 1 }}</p>

        </td>

      </template>
      <template #docDate="{item}">

        <td>
          <p  style="text-align: center">{{ get_date(item.docDate) }}</p>

        </td>

      </template>

      <template #warehouse="{item}">
        <td>
          <p >{{ item.placeName }}</p>

        </td>

      </template>
      <template #price="{item}">

        <td>
          <p style="float: right" v-if="item.totalPrice!=null">{{ get_currency(Math.abs(item.totalPrice)) }}</p>

        </td>


      </template>
      <template #customer="{item}">

        <td>
          <p >{{ item.partyName }}</p>

        </td>

      </template>
      <template #toziKonande="{item}">

        <td>
          <p v-if="item.toziKonande!=null" >{{ item.toziKonande }}</p>

        </td>

      </template>
      <template #user="{item}">

        <td>
          <p >{{ item.createdBy }}</p>

        </td>

      </template>
      <template #baseMasterCode="{item}">
        <td>
          <p class="text-center">{{ item.baseMasterCode }}</p>
        </td>
      </template>
      <template #partyCode="{item}">
        <td>
          <p class="text-center">{{ item.partyCode }}</p>
        </td>
      </template>
      <template #masterCode="{item}">
        <td>
          <p class="text-center">{{ item.masterCode }}</p>
        </td>
      </template>

      <template #operation="{item}">
        <td >
          <CButton v-if="item.statusId ==0"

                   size="sm"
                   :title="$t('buttons.delete')"
                   @click="delete_item_dialog(item)"
          >
            <CIcon name="cil-trash" class="text-danger" />
          </CButton>
        </td>
      </template>

      <template #select="{item}">
        <td >

          <CCol v-if="item.statusId !=0 && item.toziKonande==null">

            <input type="checkbox" ref="permissions[]" v-model="id_checkbox_items"
                   :value="item.recId"/>

          </CCol>

        </td>
      </template>
      <template #caption>
        <tr class="total-table">
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>

            {{ get_currency(Math.abs(calculate_items(items_buy_filtered_no_ref,'totalPrice'))) }}
          </td>
        </tr>
      </template>

    </CDataTable>
    <CDataTable
            v-if="selected_type==12"
            :items="items_sell_filtered_no_ref"
            :fields="buy_fields"
            column-filter
            @row-clicked="table_row_clicked"

            :items-per-page="20"
            hover
            sorter
            border
            striped
            :sorter-value="{column:'recId',asc:false}"
            pagination
    >
      <template #row="{item,index}">

        <td>
          <p style="text-align: center" >{{ index + 1 }}</p>

        </td>

      </template>
      <template #docDate="{item}">

        <td>
          <p  style="text-align: center">{{ get_date(item.docDate) }}</p>

        </td>

      </template>

      <template #warehouse="{item}">
        <td>
          <p >{{ item.placeName }}</p>

        </td>

      </template>
      <template #price="{item}">

        <td>
          <p style="float: right" v-if="item.totalPrice!=null">{{ get_currency(Math.abs(item.totalPrice)) }}</p>

        </td>


      </template>
      <template #customer="{item}">

        <td>
          <p >{{ item.partyName }}</p>

        </td>

      </template>
      <template #toziKonande="{item}">

        <td>
          <p v-if="item.toziKonande!=null" >{{ item.toziKonande }}</p>

        </td>

      </template>
      <template #user="{item}">

        <td>
          <p >{{ item.createdBy }}</p>

        </td>

      </template>
      <template #baseMasterCode="{item}">
        <td>
          <p class="text-center">{{ item.baseMasterCode }}</p>
        </td>
      </template>
      <template #partyCode="{item}">
        <td>
          <p class="text-center">{{ item.partyCode }}</p>
        </td>
      </template>
      <template #masterCode="{item}">
        <td>
          <p class="text-center">{{ item.masterCode }}</p>
        </td>
      </template>

      <template #operation="{item}">
        <td >
          <CButton v-if="item.statusId ==0"

                   size="sm"
                   :title="$t('buttons.delete')"
                   @click="delete_item_dialog(item)"
          >
            <CIcon name="cil-trash" class="text-danger" />
          </CButton>
        </td>
      </template>

      <template #select="{item}">
        <td >

          <CCol v-if="item.statusId !=0 && item.toziKonande==null">

            <input type="checkbox" ref="permissions[]" v-model="id_checkbox_items"
                   :value="item.recId"/>

          </CCol>

        </td>
      </template>
      <template #caption>
        <tr class="total-table">
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>

            {{ get_currency(Math.abs(calculate_items(items_sell_filtered_no_ref,'totalPrice'))) }}
          </td>
        </tr>
      </template>

    </CDataTable>


    <CModal
            :show.sync="change_status_modal"
            :no-close-on-backdrop="true"
            color="transparent"
            border-color="primary"
            size="sm"
            :title="$t('components.changeStatus')"
    >

      <CRow>
        <CCol col="12">
          <CSelect
                  :label="$t('inventory')"
                  :options="place_items"
                   :value.sync="selected_place"/>

        </CCol>
      </CRow>
      <template #footer>
        <CButton @click="return_items()"
                 color="success"
        >{{ $t("buttons.ok") }}
        </CButton>
        <CButton
                @click="change_status_modal = false"
                color="danger"
        >{{ $t("buttons.cancel") }}
        </CButton>
      </template>
    </CModal>
    <CModal
        :show.sync="show_factor_detail"
        :no-close-on-backdrop="true"
        :centered="true"
        :title="$t('InventoryBill')"
        size="lg"
        color="dark"
    >
      <CCard >
        <CCardHeader>
          <strong>{{ $t('TempReturnDoc') }}</strong>

        </CCardHeader>
        <CCardBody>
          <CRow>
  <CCol col="3">{{$t('tables.row')}} : {{selected_factor.masterCode}}</CCol>
            <CCol col="3">{{ $t('BaseInvoiceNo') }} : {{ selected_factor.baseMasterCode }}</CCol>
            <CCol col="6">{{$t('customer')}} : {{selected_factor.partyCode}} {{selected_factor.partyName}}</CCol>

            <CCol col="3">{{$t('tables.date')}} : {{get_date(selected_factor.docDate)}}</CCol>

            <CCol col="3">{{$t('inventory')}} : {{selected_factor.placeName}}</CCol>

            <CCol col="3">{{$t('tables.status')}} : {{selected_factor.ReasonName}}</CCol>

</CRow>
          <CDataTableFixed
              :items="selected_factor_detail"
              :fields="factor_product_fields"
              striped
              height="200px"

              border
              :items-per-page="200"
              hover
              pagination
          >
            <template #row="{item,index}">

              <td>
                <p  style="text-align: center">{{ index + 1 }}</p>

              </td>

            </template>
            <template #name="{item}">

              <td>
                <p >{{ item.productCode }} {{ item.productName }}</p>

              </td>

            </template>

            <template #qty="{item}">
              <td>
                <p  style="text-align: center">{{ Math.abs(item.qty) }}</p>
              </td>
            </template>

            <template #price="{item}">
              <td>
                <p  style="text-align: right">{{ get_currency(Math.abs(item.price)) }}</p>
              </td>
            </template>

            <template #discount="{item}">
              <td>
                <p  style="text-align: right">{{ get_currency(item.discount) }}</p>
              </td>
            </template>

            <template #tax="{item}">
              <td>
                <p   style="text-align: right">{{ get_currency(item.tax) }}</p>
              </td>
            </template>
            <template #totalPrice="{item}">

              <td>
                <p style="float: right" >{{get_currency(Math.abs(item.totalPrice))}} </p>

              </td>

            </template>

            <template #summary="{item}">

              <td>
                <strong >{{ item.summary }}</strong>

              </td>

            </template>

            <template #under-table="{item}">
              <CRow>
                <CCol></CCol>
                <CCol></CCol>
                <CCol></CCol>
                <CCol>
                  {{ $t('totalCirculation') }}: {{ currency_with_symbol(Math.abs(calculate_items(selected_factor_detail, "totalPrice")) ) }}
                </CCol>
                <CCol></CCol>
              </CRow>
            </template>

          </CDataTableFixed>



        </CCardBody>

      </CCard>


      <template #footer>
        <CButton v-if="selected_factor.statusId==0"
            color="secondary"
            @click="finalize_factor()"
        >{{$t('Confirm')}}
        </CButton>
        <CButton
            @click="show_factor_detail = false"
            color="success"
        >{{ $t("buttons.close") }}
        </CButton>
      </template>
    </CModal>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import moment from 'moment-jalaali'

var items = [];
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'

var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
export default {
  name: 'Login',
  components: {
    Treeselect,

  },
  data() {
    return {
      confirm_confirm_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      confirm_delete_name: "delete" + new Date().getTime() + "_" + this.$vnode.tag,
      place_items: [],
      show_factor_detail: false,

      selected_place:0,
      items_sell_filtered: [],
      items_buy_filtered: [],
      items_sell: [],
      items_buy: [],
      items_buy_no_ref: [],
      items_buy_filtered_no_ref: [],
      items_sell_no_ref: [],
      items_sell_filtered_no_ref: [],
      change_status_modal:false,
      start_date: '',
      end_date: '',
      selected_factor: {},
      selected_factor_detail: [],
      search_factor_text: null,
      selected_factors_for_status: [],
      selected_status: 0,
      status_list: [{label: this.$t('select'), value: 0}, {label: this.$t('inDriver'), value: 25}],
      // 23	ارجاع	10
      // 24	کالاها آماده ارسال	10
      // 25	تحویل سفیر	10
      // 26	در دست سفیر	10
      // 27	در مسیر تحویل	10
      // 28	تحویل شد	10
      change_status_summary: '',
      id_checkbox_items: [],
      selected_type: 4,
      type_items: [
        {label: this.$t('components.buyRet'), value: 2},
        {label: this.$t('components.sellRet'), value: 4},
        {label: this.$t('buyCurrencyRet'), value: 8},

      ],
      factor_product_fields: [
        {key: 'row', label: this.$t('tables.sharp'),sorter:false, _style: 'width:2%'},
        {key: 'name', label: this.$t('components.productName'), _style: 'width:20%'},
        // {key: 'placeName', label: this.$t('sidebars.inventory') , _style: 'width:15%'},
        {key: 'qty', label: this.$t('tables.qty'), _style: 'width:5%'},
        {key: 'price', label:this.$t('components.unitPrice')  , _style: 'width:10%'},
        {key: 'discount', label:this.$t('tables.off') , _style: 'width:10%'},
        {key: 'tax', label: this.$t('vat'), _style: 'width:10%'},
        {key: 'totalPrice', label: this.$t('tables.amount'), _style: 'width:10%'},
        {key: 'summary', label: this.$t('tables.summary'), _style: 'width:15%'},
      ],
      sell_fields: [
        {key: 'row', label: this.$t('tables.sharp'),sorter:false, _style: 'width:2%'},
        {key: 'docDate', label: this.$t('tables.date'), _style: 'width:10%'},
        {key: 'masterCode', label: this.$t('docNumber'), _style: 'width:10%'},
        {key: 'baseMasterCode', label: this.$t('factor'), _style: 'width:10%'},
        {key: 'partyCode', label: this.$t('customerCode'), _style: 'width:10%'},
        {key: 'customer', label: this.$t('components.customer'), _style: 'width:20%'},
        {key: 'user', label: this.$t('SalesPerson'), _style: 'width:15%'},

        {key: 'price', label: this.$t('tables.amount'), _style: 'width:7%'},

        {key: 'operation', label: "", _style: 'width:3%', sorter: false, filter: false},
        // {key: 'select', label: "", _style: 'width:3%', sorter: false, filter: false},

      ],
      buy_fields: [
        {key: 'row', label: this.$t('tables.sharp'),sorter:false, _style: 'width:2%'},
        {key: 'docDate', label: this.$t('tables.date'), _style: 'width:15%'},

        // {key: 'recId', label: this.$t('tables.number'), _style: 'width:2%'},
        {key: 'masterCode', label: this.$t('reference'), _style: 'width:10%'},
        {key: 'baseMasterCode', label: this.$t('factor'), _style: 'width:10%'},
        {key: 'partyCode', label: this.$t('supplierCode'), _style: 'width:10%'},
        {key: 'customer', label: this.$t('supplier'), _style: 'width:20%'},
        {key: 'user', label: this.$t('createdBy'), _style: 'width:15%'},

        {key: 'price', label: this.$t('tables.amount'), _style: 'width:10%'},


        // {key: 'ReasonName', label: this.$t('tables.status'), _style: 'width:10%'},
       {key: 'operation', label: "", _style: 'width:5%;',sorter:false,filter:false},

      ],
      table_clicks_timer: '',
      table_clicks: 0,

      status_form: 0,
      refer_messages: [],
      selected_factor_id: 0,
      check_all_exit: false,
      normalizer_factors(node) {
        return {
          id: node.recId,
          label: node.masterCode + " " + node.partyName,
        }
      },
    }
  },
  mounted() {
    if(this.get_access("return_no_reference")){
      this.type_items.push( {label: this.$t('buyReturnWithoutResource'), value: 11})
      this.type_items.push( {label: this.$t('saleReturnWithoutResource'), value: 12})
    }
    this.start_date = this.get_day_before_today(1);
    this.end_date = this.get_today();
    bus.$on("return_doc_added", (data) => {
      this.get_all_data();
    });
    this.$root.root_validate_errors = [];
this.get_places()
    this.get_all_data();
    this.get_messages();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    '$route.params.cat_id': function () {
      this.get_all_data();
    },
    'start_date': function () {
      this.get_all_data();
    },
    'end_date': function () {
      this.get_all_data();
    },
    'selected_type': function () {
      // this.get_all_data();
    },
    'check_all_exit': function () {
      if (this.check_all_exit) {
        this.id_checkbox_items = [];

        this.transfer_product_inventory_items.forEach((val) => {
          this.id_checkbox_items.push(val.recId);
        });
      } else {
        this.id_checkbox_items = [];
      }
    },

  },
  methods: {

    get_lists_buy() {

      var self = this;


      const formData = new FormData();

      var url = "GetDocsByParams";
      formData.append("docType", 2);
      formData.append("PersonId", 0);

      formData.append("FirstDate", self.start_date);
      formData.append("SecondDate", self.end_date);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {


          self.items_buy = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
          self.items_buy = self.items_buy.filter(x=>x.statusId == 0);
          self.items_buy_filtered = self.items_buy



        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
              .catch(function (error) {

                console.log(error);
              });


    },
    get_lists_sell() {

      var self = this;


      const formData = new FormData();

      var url = "GetDocsByParams";
      formData.append("docType", 4);

        formData.append("PersonId", 0);


      // formData.append("id", 3);

      formData.append("FirstDate", self.start_date);
      formData.append("SecondDate", self.end_date);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {


          self.items_sell = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
          self.items_sell = self.items_sell.filter(x=>x.statusId == 0);
          self.items_sell_filtered = self.items_sell


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
        }
      })
              .catch(function (error) {

                console.log(error);
              });


    },

    get_lists_no_refference(type) {

      var self = this;


      const formData = new FormData();

      var url = "GetDocsByParams";
      formData.append("docType", type);

        formData.append("PersonId", 0);


      // formData.append("id", 3);

      formData.append("FirstDate", self.start_date);
      formData.append("SecondDate", self.end_date);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {

if(type==11){
  self.items_buy_no_ref = content_data.data.map((item, row_id) => {
    return {...item, row_id}
  });
  self.items_buy_no_ref = self.items_buy_no_ref.filter(x=>x.statusId == 0);
  self.items_buy_filtered_no_ref = self.items_buy_no_ref


}
if(type==12){
  self.items_sell_no_ref = content_data.data.map((item, row_id) => {
    return {...item, row_id}
  });
  self.items_sell_no_ref = self.items_sell_no_ref.filter(x=>x.statusId == 0);
  self.items_sell_filtered_no_ref = self.items_sell_no_ref


}

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
        }
      })
              .catch(function (error) {

                console.log(error);
              });


    },

    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        // this.goShowDocument(item)
        this.table_clicks = 0
        this.get_document_details(item);

      }

    },

    get_places() {
      var self = this;
      self.places_items = [];
      this.$apis.get_places().then(result =>{
        self.places_items = result
        self.selected_place = self.places_items[0].value;

      })


    },
    load_factors({action, searchQuery, callback}) {
      var self = this;

      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {
          let options;
          var self = this;


          const formData = new FormData();

          var url = "GetDocsByParams";
          formData.append("docType", this.selected_type);
          formData.append("PersonId", 0);

          // formData.append("id", 3);
          formData.append("SearchTxt", searchQuery);
          formData.append("FirstDate", self.start_date);
          formData.append("SecondDate", self.end_date);

          axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {

              options = response.data.data;

              callback(null, options);

            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
            }

          })
              .catch(function (error) {

                console.log(error);
              });
        })
      }
    },

    get_document_details(item_doc) {
      var self = this;

this.id_checkbox_items = [];
      const formData = new FormData();

      var url = "GetDocItemsByDocId";
self.selected_factor = item_doc
self.selected_factor_id = item_doc.recId
      formData.append("id", item_doc.recId);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.show_factor_detail = true;
          // this.status_form = item.masterId;
          self.selected_factor_detail = content_data.data;
          self.selected_factor_detail.forEach(function (val){
            val.TotalPrice = parseFloat(val.price)*parseFloat(val.qty)
          })
// console.log("products is",self.selected_factor_detail)
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    get_messages() {
      var self = this;
      const formData = new FormData();

      var url = "GetFactorReferMessages";

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.refer_messages = self.sort_array([],content_data.data,"id",'title');


        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);
        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    check_all() {
      console.log('check all clicked');
    },
    goShowDocument(item) {

      this.$router.push({path: '/dashboard/documents/show/' + item.recId});
    },


    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.name != '' && this.color != '') {
        return true;
      }


      if (this.name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }

      if (this.color == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertColor'));
      }
      // if (this.description == '') {
      //   this.$root.root_validate_errors.push(this.$t('dialogs.insertSummary'));
      // }
      return false;
      // e.preventDefault();
    },

    get_all_data() {
      this.get_lists_buy();
      this.get_lists_sell();
      this.get_lists_no_refference(11);
      this.get_lists_no_refference(12);
      // this.get_insite_lists()
      // this.get_delivery_lists()
    },
    get_image_file(item) {
      // console.log("image url is " + item.imageName);
      return this.$root.base_url + item.imageName;
    },
    edit_item(item) {
      // this.$set(this.items[item.row_id], '_toggled', !item._toggled)
      this.name = this.items[item.row_id].catTitle;
      this.color = this.items[item.row_id].color;
      this.code = item.code;
      this.description = this.items[item.row_id].summary;
      this.previewImage = this.items[item.row_id].image;
      this.status_form = this.items[item.row_id].recId;
      setTimeout(() =>
              this.$refs.add_container.scrollIntoView()
          , 500);
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    emptyList() {
      // this.$set(this.items[item.row_id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '/img/placeholder.png';
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },

    goSubCategories(item, index) {

      this.$router.push({path: '/dashboard/base/categories/' + this.items[index].recId});
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    goToProductList(item) {
      this.$router.push({path: "/dashboard/products/list-cat/" + item.recId})
      // this.$router.push({ path: '/dashboard/base/categories/'+this.items[index].recId});
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    handleFileUpload(files, e) {
      this.file = e.target.files[0];
      this.previewImage = URL.createObjectURL(this.file);
    },
    insert_data() {


      if (!this.validateForm()) {
        // console.log("validate form is false"+this.validate_errors);
        return true;
      }

      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddMainCat";
      } else {
        url = "EditMainCat";
        formData.append('id', this.status_form)

      }

      formData.append('file', this.file);
      formData.append('MainCatTitle', this.name);
      formData.append('Color', this.color);
      formData.append('Code', this.code);
      if (this.$route.params.cat_id != null) {
        formData.append('IsParent', this.$route.params.cat_id);

      } else {
        formData.append('IsParent', 0);

      }
      formData.append('summary', this.description);
      axios.post(url, formData, {}).then((res) => {



        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;
        self.name = '';
        self.color = '#ffffff';
        self.code = '';
        self.description = '';
        self.previewImage = '/img/placeholder.png';
        self.get_all_data();


      })

          // axios.post(  '/admin/category', {
          //     name: self.name,
          //     description: self.description,
          //     image: self.image,
          //     cat: 0,
          // }).then(function (response) {
          //     self.name = '';
          //     self.description = '';
          //     // localStorage.setItem("api_token", response.data.access_token);
          //     // self.$router.push({ path: 'notes' });
          // })
          .catch(function (error) {
            console.log(error);
          });

    },
    finalize_factor() {
      var self = this;


      const formData = new FormData();

      var url = "AddFactorToFinal";
console.log(this.selected_factor)
      formData.append("id", this.selected_factor_id);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        self.$root.modal_component.show_api_response_modals(response);

        if (content_data.statusCode == 0) {
          self.show_factor_detail = false
          self.get_all_data();
          bus.$emit("finalize_return_doc", "");
          // self.get_document_master("print");
        } else {
          // self.$root.modal_component.show_danger_modal('خطا', content_data.message);
        }
      }).catch(function (error) {

            console.log(error);
          });

    },
    confirm_dialog() {
      if(this.id_checkbox_items.length==0){
this.$root.modal_component.show_validate_errors([this.$t('selectOneProduct')])
        return false;
      }
      // this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("sureToReturn"), [this.$t("dialogs.ok")], this.confirm_delete_name);
      this.change_status_modal = true;

    },
    return_items() {

      let self = this;
      const formData = new FormData()
      let url;
      url = "AddFactorReturn";

self.change_status_modal = false;
      formData.append('BaseFactorId', this.search_factor_text);
      formData.append('PlaceId', this.selected_place);
      formData.append('DocTypeId', this.selected_type+1);
      var details = [];
      for(var i=0;i<this.id_checkbox_items.length;i++){
        details.push({
          DetailId: this.id_checkbox_items[i],
          MasterId: this.search_factor_text,
          ProductId:this.transfer_product_inventory_items.filter(x=>x.detailId==this.id_checkbox_items[i])[0].productId,
          Qty:this.transfer_product_inventory_items.filter(x=>x.detailId==this.id_checkbox_items[i])[0].retQty,
        RetMessageId:this.transfer_product_inventory_items.filter(x=>x.detailId==this.id_checkbox_items[i])[0].selected_message,
                })
      }

      formData.append('Details', JSON.stringify(details));

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.search_factor_text=null;
        self.transfer_product_inventory_items= [];
        self.selected_factor= {};

      })
              .catch(function (error) {

                console.log(error);
              });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = item.recId;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteFactorMaster";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        // self.get_lists();
        //  this.$router.push({ path: '/dashboard/documents/daily-list/0'});
        self.get_all_data();

      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },

  }
}

</script>
